import * as QuicksightEmbedding from 'amazon-quicksight-embedding-sdk';

import React, {useEffect, useState} from 'react';

import { MatrixService } from "../services/matrixservice";
import { MatrixSettings } from "../models/matrixSettings";
import { SpinnerContainer } from "./shared/SpinnerContainer";
import axios from 'axios';

const matrixService = new MatrixService();
const matrixSettings = new MatrixSettings();

const apiURL = 	matrixSettings.awsUrl + "/qs-get-embed-url/?dashboardId="

const embedDashboard = async (dashboardId: string, reportType: string) => {

    const _axiosHeaders = await matrixService.getHeaders();

    const command = apiURL + dashboardId + '&reportType=' + reportType;
    
    const response = await axios.get(command, {"headers": _axiosHeaders});
    const containerDiv = document.getElementById('embeddingContainer');

    const options = {
        url: response.data.EmbedUrl,
        container: containerDiv,
        scrolling: 'yes',
        width: '100%',
        printEnabled: 'yes'
    };

    QuicksightEmbedding.embedDashboard(options);
}

export type Props = {
  dashboardId: string,
  reportType: string
}

function Dashboard(props: Props) {

  const [dashId] = useState(props.dashboardId);
  const [reportType] = useState(props.reportType);
  const [dashLoaded, setDashLoaded] = useState(false);

  useEffect(() => {
    
    const getDash = async () => {
      setDashLoaded(false);

      await embedDashboard(dashId, reportType);

      setDashLoaded(true);
    } 

    getDash();
  
  }, [dashId, reportType]);
  
  return (
    <div>
      {!dashLoaded &&

        <div className="tw-h-screen">
          <div className= "tw-h-4/6 tw-grid tw-w-full tw-place-content-center">
            <SpinnerContainer />
          </div>
        </div>

      }
      <div id="embeddingContainer" style={{overflow: "auto", height: "80vh", minWidth: "100%"}}>
      </div>
    </div>
  );

  
}

export default Dashboard;